import { connectSearchBox } from 'instantsearch.js/es/connectors';

/**
 * Créée une searchbox custom
 *
 * @param {array} renderOptions
 * @param {bool} isFirstRender
 */
const renderSearchBox = (renderOptions, isFirstRender) => {
  const { query, refine } = renderOptions;
  const {
    container,
    placeholder,
    autofocus,
    showSubmit,
    inputId,
  } = renderOptions.widgetParams;

  const containerElement = document.querySelector(container);
  const formElement = document.querySelector('#form-container');

  if (isFirstRender) {
    const input = document.createElement('input');
    input.className = 'form-control';
    input.id = inputId;
    input.placeholder = placeholder;
    input.autofocus = autofocus;
    input.autocomplete = 'off';
    input.setAttribute('list', 'chassis-list');

    formElement.addEventListener('submit', (event) => {
      event.preventDefault();
    });

    input.addEventListener('input', (event) => {
      event.preventDefault();
      refine(event.target.value);
    });

    containerElement.appendChild(input);

    if (showSubmit) {
      const submitIcon = document.createElement('i');
      submitIcon.className = 'icon-search';
      submitIcon.addEventListener('click', () => {
        refine(input.value);
      });

      containerElement.appendChild(submitIcon);
    }
  }

  containerElement.querySelector('#chassis').value = query;
};

export const customSearchBox = connectSearchBox(renderSearchBox);
